// Encryption with enhanced security
export const encryptData = async (text, key) => {
    // Input validation
    if (!text || typeof text !== 'string') {
        throw new Error('Invalid input: text must be a non-empty string')
    }
    
    if (!key || !(key instanceof CryptoKey)) {
        throw new Error('Invalid input: key must be a valid CryptoKey')
    }
    
    // Check key usage
    if (!key.usages.includes('encrypt')) {
        throw new Error('Invalid key: key must support encryption')
    }
    
    // Generate secure random IV (12 bytes for AES-GCM)
    const iv = crypto.getRandomValues(new Uint8Array(12))
    
    // Encode text
    const encoder = new TextEncoder()
    const encodedText = encoder.encode(text)
    
    // Additional length check
    if (encodedText.length > 1024 * 1024) { // 1MB limit
        throw new Error('Input too large: maximum 1MB allowed')
    }

    try {
        const ciphertext = await crypto.subtle.encrypt(
            {
                name: "AES-GCM",
                iv: iv,
                tagLength: 128 // Explicit tag length for security
            },
            key,
            encodedText
        )

        return {
            ciphertext: new Uint8Array(ciphertext),
            iv: iv,
            algorithm: 'AES-GCM',
            tagLength: 128
        }
    } catch (error) {
        // Clear sensitive data
        iv.fill(0)
        encodedText.fill(0)
        
        throw new Error(`encryptData() failed: ${error.message}`)
    }
}


export default encryptData